/**
 * @generated SignedSource<<fe26da409e939aea091ff824ee2db3c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RecipientType = "EMAIL" | "LINK" | "QR_CODE" | "SMS" | "SMS_CODE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RecipientListInput_recipientList$data = {
  readonly id: string;
  readonly recipients: ReadonlyArray<{
    readonly emailAddress: string | null | undefined;
    readonly phoneNumber: string | null | undefined;
    readonly preRegisteredMetaQuestionResponses: ReadonlyArray<{
      readonly questionId: string;
      readonly selectedResponseOptions: ReadonlyArray<{
        readonly value: number;
      }>;
    }>;
    readonly respondentId: string;
    readonly type: RecipientType;
  }>;
  readonly " $fragmentType": "RecipientListInput_recipientList";
};
export type RecipientListInput_recipientList$key = {
  readonly " $data"?: RecipientListInput_recipientList$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecipientListInput_recipientList">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecipientListInput_recipientList",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Recipient",
      "kind": "LinkedField",
      "name": "recipients",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "emailAddress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "phoneNumber",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "respondentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "QuestionResponse",
          "kind": "LinkedField",
          "name": "preRegisteredMetaQuestionResponses",
          "plural": true,
          "selections": [
            {
              "alias": "questionId",
              "args": null,
              "kind": "ScalarField",
              "name": "originalQuestionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ResponseOptionResponse",
              "kind": "LinkedField",
              "name": "selectedResponseOptions",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecipientList",
  "abstractKey": null
};

(node as any).hash = "5d8fe4fb262eb74602344de7364218ef";

export default node;
